import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef } from "react";
import { RECAPTCHA_SITE_KEY } from "@globalConfig";
var SCRIPT_ID = "recaptcha-api-js";
var SCRIPT_SRC = "https://www.google.com/recaptcha/api.js?render=explicit";

// Loads grecaptcha api.js once, resolves when window.grecaptcha is ready.
var loadGrecaptcha = function loadGrecaptcha() {
  return new Promise(function (resolve, reject) {
    var w = window;
    if (w.grecaptcha && w.grecaptcha.render) {
      resolve(w.grecaptcha);
      return;
    }
    var script = document.getElementById(SCRIPT_ID);
    var onReady = function onReady() {
      if (w.grecaptcha && w.grecaptcha.render) resolve(w.grecaptcha);else reject(new Error("grecaptcha unavailable"));
    };
    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src = SCRIPT_SRC;
      script.async = true;
      script.defer = true;
      script.onerror = function () {
        return reject(new Error("recaptcha script failed"));
      };
      document.head.appendChild(script);
    }
    // api.js doesn't fire a load event reliably for explicit mode; poll.
    var start = Date.now();
    var timer = setInterval(function () {
      if (w.grecaptcha && w.grecaptcha.render) {
        clearInterval(timer);
        onReady();
      } else if (Date.now() - start > 10000) {
        clearInterval(timer);
        reject(new Error("recaptcha load timeout"));
      }
    }, 200);
  });
};
var ReCaptcha = function ReCaptcha(_ref) {
  var onChange = _ref.onChange,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? "ar" : _ref$lang;
  var containerRef = useRef(null);
  var widgetIdRef = useRef(null);
  useEffect(function () {
    if (!__IS_CSR__) return;
    var cancelled = false;
    loadGrecaptcha().then(function (grecaptcha) {
      if (cancelled || !containerRef.current) return;
      if (widgetIdRef.current !== null) return; // already rendered
      widgetIdRef.current = grecaptcha.render(containerRef.current, {
        sitekey: RECAPTCHA_SITE_KEY,
        hl: lang,
        callback: function callback(token) {
          return onChange(token);
        },
        "expired-callback": function expiredCallback() {
          return onChange(null);
        },
        "error-callback": function errorCallback() {
          return onChange(null);
        }
      });
    })["catch"](function () {
      return onChange(null);
    });
    return function () {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef
  });
};
export default ReCaptcha;